export enum InboxStatusEnum {
  active = 'active',
  snoozed = 'snoozed',
  done = 'done',
}
